import styled from 'styled-components'
import { typoHeading6 } from '../../lib/styles/Typography'

export const Styled = {
  Wrapper: styled.div`
    margin: 3rem 0;
    padding: 1.5rem 0;
    border-top: solid 1px ${({ theme }) => theme.colors.black[6]};
    border-bottom: solid 1px ${({ theme }) => theme.colors.black[6]};
  `,
  Headline: styled.div`
    ${typoHeading6}
    margin-bottom: 1rem;
  `,
}
